export const DATA_QA_PREVIEW_VIDEO = 'product-video';
export const DATA_QA_PREVIEW_VIDEO_SOURCE = 'product-video-source';
export const DATA_QA_PLAY_ICON_WRAP = 'play-icon-wrap';
export const DATA_QA_PLAY_VIDEO = 'play-icon';
export const DATA_QA_VIDEO_SEO_LINK = 'video-seo-link';
export const DATA_QA_VIDEO_SEO_NAME = 'video-seo-name';
export const DATA_QA_VIDEO_SEO_DESCRIPTION = 'video-seo-description';
export const DATA_QA_VIDEO_SEO_FAMILY_FRIENDLY = 'video-seo-family-friendly';
export const DATA_QA_VIDEO_SEO_IMAGE_LINK = 'video-seo-image-link';
export const DATA_QA_VIDEO_SEO_UPLOAD_DATE = 'video-seo-upload-date';
export const DATA_QA_MEDIA_PREVIEW_VIDEO = 'media-preview-video';

export const DATA_QA_MOBILE_GALLERY_ITEM_WRAPPER = 'mobile-gallery-item-wrapper';
export const DATA_QA_MOBILE_GALLERY_THUMB_CIRCLE = 'mobile-gallery-thumb-circle';
export const DATA_QA_MOBILE_GALLERY_THUMB_TRIANGLE = 'mobile-gallery-thumb-triangle';
export const DATA_QA_MOBILE_GALLERY_ROOT_CONTAINER = 'mobile-gallery-root-container';
export const DATA_QA_MOBILE_GALLERY_LIST_WRAPPER = 'mobile-gallery-list-wrapper';
export const DATA_QA_MOBILE_GALLERY_THUMBS_WRAPPER = 'mobile-gallery-thumbs-wrapper';

export const DATA_QA_DESKTOP_GALLERY = 'desktop-media-gallery';

export const DATA_QA_VIDEO_ARROW_LEFT = 'video-arrow-left';
export const DATA_QA_VIDEO_ARROW_RIGHT = 'video-arrow-right';
